/*

Classes are specified in global.scss.

*/

import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

const fontIdClassMap = {
  1: 'sans-font-family',
  2: 'serif-font-family',
  3: 'cursive-font-family',
  4: 'mono-font-family',
}

@Component
class GlobalStylesMixin extends Vue {
  @Getter private fontId

  get globalStyleClasses(): string[] {
    return [fontIdClassMap[this.fontId]]
  }
}

export default GlobalStylesMixin
